const Throttle=(func, delay)=> {
    let lastCalled = 0;
    return function(...args) {
        const now = Date.now();
        if (now - lastCalled >= delay) {
            func.apply(this, args);
            lastCalled = now;
        }
    };
}

export default Throttle
